import stat from "../../utils/stat";
import { createElement } from "./PluginCustomProgress";
import intl from "react-intl-universal";

const PluginControlBar = window.Aliplayer
  ? window.Aliplayer.Component({
      init: function (duration: number) {
        this.el = null;
        this.show = false;
        this.duration = duration;
        this.timer = 0;
      },
      createEl: function (el: any, player: any) {
        this.el = el;

        const controlBar = this.el.querySelector(".prism-controlbar");
        const video = this.el.querySelector("video");

        controlBar.style.display = "none";

        video.addEventListener("click", () => {
          clearTimeout(this.timer);
          this.show = !this.show;

          if (this.show) {
            controlBar.style.display = "block";

            if (this.duration) {
              this.timer = setTimeout(() => {
                this.show = false;
                controlBar.style.display = "none";
              }, this.duration);
            }
          } else {
            controlBar.style.display = "none";
          }
        });
      },
    })
  : null;

export default PluginControlBar;
